import api from './api';

class PaymentService {
    async initializePayment(data) {
        return api.post('payments/process_payment/', data);
    }

    async verifyPayment(data) {
        return api.post('payments/verify_payment/', data);
    }

    async getPayments() {
        return api.get('payments/');
    }
}

export default new PaymentService();
